<template>
	<div id="app" v-bind:class="[`view-${$route.name}`]">

		<transition name="fade" mode="out-in">
			<router-view ref="router" style="animation-duration: 0.3s"></router-view>
		</transition>

	</div>
</template>

<script>

import { mapState } from 'vuex';

export default {
	
	name: 'app',
	
	computed: {
		...mapState('settings', ['config']),
		...mapState('localSettings', ['configKey'])
	},

	data: () => ({
		dataRepository: false,
		comp: {},
	}),

	mounted() {
		this.$store.dispatch('localSettings/SET_DEFAULT_CONFIGURATION');
		this.$store.dispatch('localSettings/SAVE');
	},

	methods: {
		
	}
}
</script>

<style lang="scss">

</style>
